var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 18C16.433 18 18 16.433 18 14.5C18 12.567 16.433 11 14.5 11C12.567 11 11 12.567 11 14.5C11 16.433 12.567 18 14.5 18Z",
    stroke: "#222222",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3975 13.2123C24.8666 13.7818 25.1011 14.0665 25.1011 14.5C25.1011 14.9336 24.8666 15.2182 24.3975 15.7877C22.6815 17.8711 18.8968 21.75 14.5037 21.75C10.1105 21.75 6.32573 17.8711 4.60979 15.7877C4.14076 15.2182 3.90625 14.9336 3.90625 14.5C3.90625 14.0665 4.14076 13.7818 4.60979 13.2123C6.32573 11.1289 10.1105 7.25 14.5037 7.25C18.8968 7.25 22.6815 11.1289 24.3975 13.2123Z",
    stroke: "#222222",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewEye);
export default __webpack_public_path__ + "static/media/view-eye.33c3c18bd338c7d8d28f5edb863c35a2.svg";
export { ForwardRef as ReactComponent };